export default {"src":"/_next/static/media/two-people-high-five.572e550e.svg","height":245,"width":327,"blurWidth":0,"blurHeight":0};